import { Box, Paper, Tab, Tabs } from "@mui/material";
import React from "react";

import { useBOMDashboardContext } from "./BOMDashboard.context";

import TabPanelFormat from "../../../../../../components/widgets/TabPanelFormat";
import {
  getHashdataUrl,
  setHashUrl,
} from "../../../../../../components/Tabs/Utils/hashFunctions";
import { BOMTabs } from "./BOMTabs";
import useStandaloneView from "../../../../../../hooks/useStandaloneView";

export default function BOMMain() {
  const { tabType, currentTab, setCurrentTab } = useBOMDashboardContext();
  const standalone = useStandaloneView();

  const tabs = BOMTabs(tabType);
  const navLabel = tabType === "bom" ? "bom-tab" : "pnid-tab";

  // const fullHash = window.location.hash;
  // React.useEffect(() => {
  //   const hashValue = getHashdata(fullHash, navLabel);
  //   const tabIndex = tabs.findIndex(
  //     (tab) => tab.label === decodeURIComponent(hashValue)
  //   );

  //   // console.log({ tabIndex });
  //   // if hash value for tabs is present, set it as currentTab
  //   if (tabIndex !== -1) {
  //     setCurrentTab(tabIndex);
  //   }
  //   // if its not present, but there is some existing hash value, add this to the hash value
  //   else if (fullHash)
  //     window.location.hash = fullHash + "&" + navLabel + "=" + tabs[0].label;
  //   // if not either, start a new hash
  //   else window.location.hash = navLabel + "=" + tabs[0].label;
  // }, []);

  // const handleChange = (event, newValue) => {
  //   // console.log("CHNGE");
  //   setCurrentTab(newValue);

  //   setHash(fullHash, navLabel, tabs[newValue].label);
  // };

  React.useEffect(() => {
    const hashValue = getHashdataUrl(navLabel);

    const tabIndex = tabs.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue)
    );

    if (tabIndex !== -1) {
      setCurrentTab(tabIndex);
    } else {
      setHashUrl(navLabel, tabs[0].label);
    }
  }, []);

  const handleChange = (_, newValue) => {
    setCurrentTab(newValue);
    setHashUrl(navLabel, tabs[newValue].label);
  };

  return (
    <Paper sx={{ width: "100%", display: "flex" }}>
      <Box {...{ width: "100%", overflow: "auto" }}>
        {!standalone && (
          <Tabs
            value={currentTab}
            onChange={handleChange}
            orientation={"horizontal"}
          >
            {tabs.map((tab, i) => {
              return <Tab label={tab.label} value={i} />;
            })}
          </Tabs>
        )}

        <TabPanelFormat {...tabs[currentTab].panelProps}>
          {tabs[currentTab].panel}
        </TabPanelFormat>
      </Box>
    </Paper>
  );
}
